"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNICODE_NORMALIZATION_FORMS = void 0;
exports.normalizeDoubleByteToStandard = exports.default = normalizeDoubleByteToStandard;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var UNICODE_NORMALIZATION_FORMS = exports.UNICODE_NORMALIZATION_FORMS = ['NFD', 'NFC', 'NFKD', 'NFKC'];

/** normalizeDoubleByteToStandard is used to normalize a string containing
 * double-byte(Japanese, Chinese, Korean, etc) words to a standardized form
 * using the Normalization Form Canonical Composition (NFC).
 */
function normalizeDoubleByteToStandard(inputStr, unicodeNormalizationForm) {
  return inputStr.normalize((0, _includes.default)(UNICODE_NORMALIZATION_FORMS).call(UNICODE_NORMALIZATION_FORMS, unicodeNormalizationForm) ? unicodeNormalizationForm : 'NFC');
}